import { getExtensionFromName } from 'helpers/common';
import moment from 'moment';

export const formatFileToVacationModal = ({ fileName, fileId }) => ({
  name: fileName,
  type: getExtensionFromName(fileName),
  uid: fileId,
  errors: {},
});

export const validateAbsenceFormValues = (state) => {
  const { absenceType, dateStart, dateEnd, addedUsers, withAddedUsers } = state;

  const errors = [];

  if (!absenceType) errors.push('absenceType');
  if (!dateStart) errors.push('dateStart');
  if (!dateEnd) errors.push('dateEnd');
  if (withAddedUsers && addedUsers.length === 0) errors.push('withAddedUsers');

  return errors;
};

export const determineIfDatesOverlap = ({
  dateStart,
  dateEnd,
  filteredEmployeeAbsences,
  dateStartWorkingTime,
  dateEndWorkingTime,
}) => {
  let isOverlap = false;

  filteredEmployeeAbsences.forEach(
    ({ start, end, startTimeOfTheDay, endTimeOfTheDay }) => {
      if (
        dateStart &&
        dateEnd &&
        !dateStart.isSame(dateEnd, 'day') &&
        dateStart.isSame(start, 'day')
      ) {
        isOverlap = true;
      }

      if (
        dateStart &&
        dateStart.isSame(end, 'day') &&
        endTimeOfTheDay === 'morning' &&
        dateStartWorkingTime !== 'afternoon'
      ) {
        isOverlap = true;
      }

      if (
        dateStart &&
        dateEnd &&
        dateEnd.isSame(start, 'day') &&
        startTimeOfTheDay === 'afternoon' &&
        dateEndWorkingTime !== 'morning' &&
        !dateStart.isSame(dateEnd, 'day')
      ) {
        isOverlap = true;
      }

      if (
        dateStart &&
        dateEnd &&
        dateStart.isSame(dateEnd, 'day') &&
        dateStart.isSame(start, 'day') &&
        startTimeOfTheDay === 'afternoon' &&
        dateStartWorkingTime !== 'morning'
      ) {
        isOverlap = true;
      }

      if (
        dateStart &&
        dateEnd &&
        dateStart.isSame(dateEnd, 'day') &&
        dateStart.isSame(start, 'day') &&
        startTimeOfTheDay === 'morning' &&
        dateStartWorkingTime !== 'afternoon'
      ) {
        isOverlap = true;
      }

      if (dateStart && dateEnd && !dateStart.isSame(dateEnd, 'day')) {
        const momentStart = moment(start);
        const momentEnd = moment(end);
        if (
          [momentEnd, momentStart].some((existingAbsenceDate) =>
            existingAbsenceDate.isBetween(dateStart, dateEnd, 'days', '()')
          )
        ) {
          isOverlap = true;
        }
      }
    }
  );
  return isOverlap;
};
